import { signOut } from '@firebase/auth';
import { auth } from '../firebase';

const NOTICE_KEY = 'belivah:account-notice';
const BLOCKED_CODES = new Set(['account-deleted', 'account-banned', 'account-suspended']);
let handling = false;

/** Shows once on the login page after a blocked account was signed out. */
export function takeAccountNotice(): string | null {
  try {
    const msg = sessionStorage.getItem(NOTICE_KEY);
    if (msg) sessionStorage.removeItem(NOTICE_KEY);
    return msg;
  } catch {
    return null;
  }
}

/**
 * The API rejects every request from a deleted, banned or suspended account.
 * Instead of leaving the user on broken pages, sign them out with a clear message.
 * Deleted accounts also remove their own Firebase login so the account is fully gone.
 */
export function handleBlockedAccount(code: unknown): boolean {
  const c = String(code || '');
  if (!BLOCKED_CODES.has(c)) return false;
  if (handling) return true;
  handling = true;

  const message = c === 'account-deleted'
    ? 'This account has been deleted. You can create a new account to join Belivah again.'
    : c === 'account-suspended'
      ? 'This account is temporarily suspended. Please try again later or contact support.'
      : 'This account has been banned for violating our community guidelines.';
  try { sessionStorage.setItem(NOTICE_KEY, message); } catch {}

  void (async () => {
    const user = auth.currentUser;
    if (c === 'account-deleted' && user) {
      await user.delete().catch(() => undefined);
    }
    await signOut(auth).catch(() => undefined);
    window.location.replace('/login');
  })();
  return true;
}
